import {Injectable, OnDestroy} from '@angular/core';
import {BasePaginatedTableService} from "../../services/base-paginated-table.service";
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {PaginationDataSource} from '../../services/api/pagination-data-source';
import {Observable, ReplaySubject} from 'rxjs';
import {SearchQueryOptions} from '../../services/api/search-query-options';
import {takeUntil, tap, map} from 'rxjs/operators';
import {LockPolicy} from '../../_models/lock-policy';
import {ListResponse} from '../../services/api/response-types';

@Injectable({
    providedIn: 'root'
})
export class LockPolicyTableService extends BasePaginatedTableService<LockPolicy> implements OnDestroy {
    page_size = 10;
    total: number;
    page_size_options = [5, 10, 20, 50];
    page_index = 0;
    sort: MatSort;
    paginator: MatPaginator;
    dataSource: PaginationDataSource<LockPolicy>;
    search_keys = ['name'];
    lockPolicyDataSubject: ReplaySubject<{ policies: LockPolicy[] }> = new ReplaySubject(1);
    api_name = 'lock_policy';

    initialise() {
        const initialQuery: SearchQueryOptions = this.getInitialSearchOptions();
        this.paginator.pageSize = this.page_size;
        this.dataSource = new PaginationDataSource<LockPolicy>(
            (query) => this.page(query),
            initialQuery,
            this.paginator,
            this.sort
        );
        this.dataSource.$page.pipe(
            tap((result: ListResponse<LockPolicy>) => {
                this.total = result.meta.count;
                this.lockPolicyDataSubject.next({policies: result.data});
            }),
            takeUntil(this.onDestroy)
        ).subscribe();
    }

    getInitialSearchOptions(): SearchQueryOptions {
        const options = new SearchQueryOptions(this.page_size, this.page_index + 1, 'name');
        options.filters = [];
        return options;
    }

    page(query: SearchQueryOptions): Observable<ListResponse<LockPolicy>> {
        return super.page(query, this.api_name).pipe(
            map((response: ListResponse<any>) => {
                const data = response.data.map((item: any) => {
                    const policy = new LockPolicy();
                    policy.id = item.id;
                    Object.assign(policy.attributes, item.attributes);
                    if (item.relationships) {
                        Object.assign(policy.relationships, item.relationships);
                    }
                    return policy;
                });
                return {...response, data};
            })
        );
    }

    updateSort(sort: MatSort) {
        this.dataSource.sorter = sort;
        this.dataSource.refresh();
    }

    refreshData() {
        this.dataSource.refresh();
    }
}
